export enum ONBOARDING_PAYMENT_CHOSEN {
  FREE = 'FREE',
  PRO_TRIAL = 'PRO_TRIAL',
  PRO_TRIAL_YEARLY = 'PRO_TRIAL_YEARLY',
  // new - refactor later
  PRO_PLUS_TRIAL = 'TOGETHER_TRIAL',
  PRO_PLUS_TRIAL_YEARLY = 'TOGETHER_TRIAL_YEARLY',
  // Evidence Launch - new tiers
  EVIDENCE_TRIAL = 'EVIDENCE_TRIAL',
  EVIDENCE_TRIAL_YEARLY = 'EVIDENCE_TRIAL_YEARLY',
  CLINICIAN_TRIAL = 'CLINICIAN_TRIAL',
  CLINICIAN_TRIAL_YEARLY = 'CLINICIAN_TRIAL_YEARLY',
  PRACTICE_TRIAL = 'PRACTICE_TRIAL',
  PRACTICE_TRIAL_YEARLY = 'PRACTICE_TRIAL_YEARLY',
}
